import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { FloatingContact } from '../FloatingContact';
import { FloatingDolphin } from '../FloatingDolphin';

export const PublicLayout = () => {
  const loc = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' }); }, [loc.pathname]);
  return (
    <div className="min-h-screen bg-[#0a1628] text-white flex flex-col relative">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingDolphin />
      <FloatingContact />
    </div>
  );
};
